<template>
  <nav
    v-if="data?.length > 0"
    class="w-full mt-4 lg:mt-8 flex gap-x-1.5 md:gap-x-2 gap-y-1 font-medium items-center flex-wrap"
    aria-label="Breadcrumb"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    <template v-for="(item, index) in data" :key="index">
      <div
        class="flex items-center"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <NuxtLink
          v-if="index !== data.length - 1"
          :to="localePath(item.link)"
          class="transition-opacity hover:opacity-80 flex items-center"
          :class="color === 'white' ? 'text-white' : 'text-black'"
          itemprop="item"
          :aria-label="getItemAriaLabel(item, index)"
        >
          <span
            class="text-[13px] md:text-sm lg:text-base flex items-center"
            itemprop="name"
            v-html="item.title"
          ></span>
          <!-- Fallback name for SVG icon items (Google requires non-empty name) -->
          <meta v-if="index === 0 && !stripHtml(item.title)" itemprop="name" content="Ana Sayfa" />
        </NuxtLink>
        <span v-else itemprop="item" :aria-label="getItemAriaLabel(item, index)" aria-current="page">
          <span
            :class="lastItemClass"
            itemprop="name"
            v-html="item.title"
          ></span>
        </span>
        <meta itemprop="position" :content="index + 1" />
      </div>

      <!-- Ayraç -->
      <span
        v-if="index !== data.length - 1"
        class="flex items-center text-sm lg:text-base"
        :class="color === 'white' ? 'text-white' : 'text-black'"
        aria-hidden="true"
        >/</span
      >
    </template>
  </nav>
</template>

<script setup>
import { useLocalePath } from "#i18n";
import { useI18n } from "vue-i18n";
const localePath = useLocalePath();
const { t } = useI18n();

const props = defineProps({
  data: {
    type: Array,
    required: true,
    default: () => [],
  },
  color: {
    type: String,
  },
});

import { computed } from 'vue';
const lastItemClass = computed(() => [
  'text-[13px] md:text-sm lg:text-base',
  props.color === 'white' ? 'text-white border-white' : 'text-gray-500 border-gray-400',
]);

const stripHtml = (value) => {
  if (value == null) return "";
  return String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const getItemAriaLabel = (item, index) => {
  const explicit = item?.ariaLabel;
  if (explicit) return explicit;

  const extracted = stripHtml(item?.title);
  if (extracted) return extracted;

  if (index === 0) return t("Home");
  return undefined;
};
</script>
